import { api } from './api';

export interface RankingItem {
  id_militar_votado: string;
  nick: string;
  patente: string;
  votos: number;
}

export interface VotacaoDestaque {
  id: string;
  status: 'aberta' | 'fechada';
  semana_referencia: string;
  fechada_em: string | null;
  criado_em: string;
}

export interface VotacaoAtualResponse {
  votacao: VotacaoDestaque | null;
  ja_votou: boolean;
  total_votos: number;
}

export interface OficialVotou {
  id: string;
  nick: string;
  patente: string;
  patente_abreviacao: string;
}

export interface FecharVotacaoResponse {
  votacao: VotacaoDestaque;
  oficiais_votaram: OficialVotou[];
}

export const votacaoDestaqueService = {
  getAtual: async (): Promise<VotacaoAtualResponse> => {
    const response = await api.get<VotacaoAtualResponse>('/votacao-destaque/atual');
    return response.data;
  },

  getRanking: async (): Promise<RankingItem[]> => {
    const response = await api.get<RankingItem[]>('/votacao-destaque/ranking');
    return response.data;
  },

  abrir: async (): Promise<VotacaoDestaque> => {
    const response = await api.post<VotacaoDestaque>('/votacao-destaque/abrir');
    return response.data;
  },

  fechar: async (id: string): Promise<FecharVotacaoResponse> => {
    const response = await api.patch<FecharVotacaoResponse>(`/votacao-destaque/${id}/fechar`);
    return response.data;
  },

  votar: async (id_votacao: string, id_militar_votado: string): Promise<void> => {
    await api.post(`/votacao-destaque/${id_votacao}/votar`, { id_militar_votado });
  },

  getVotaram: async (id_votacao: string): Promise<OficialVotou[]> => {
    const response = await api.get<OficialVotou[]>(`/votacao-destaque/${id_votacao}/votaram`);
    return response.data;
  },
};
